import React from 'react';
import PropTypes from 'prop-types';


export const LightbulbTip = ({
  className = '',
  description,
  hasBox
}) => (
  <div className={`${className} LightbulbTip flex ${hasBox ? 'boxed' : ''}`}>
    <div className="LightbulbTip-img v-top"><img alt="lightbulb info" src="/web-2/assets/images/lightbulb.svg?v=rb" /></div>
    <div className="LightbulbTip-description margin-lg-left">{description}</div>
  </div>
);

LightbulbTip.propTypes = {
  hasBox: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};
